import React from 'react';
import MyLadsLogo from './MyLadsLogo';
import IconFacebook from '../../static/icons/_inline-svg/icon_facebook.svg';
import IconInstagram from '../../static/icons/_inline-svg/icon_instagram.svg';
import IconTwitter from '../../static/icons/_inline-svg/icon_twitter.svg';
import ExternalUrls from '../data/ExternalUrls';

export default function Footer() {
    const getYear = () => {
        return new Date().getFullYear();
    };

    return (
        <footer className="text-14 text-card-text-color">
            <div className="flex flex-col justify-center items-center pt-8 md:pt- 14 md:flex-row-reverse md:justify-between md:items-start space-y-6">
                <div>
                    <MyLadsLogo />
                </div>

                <div className="flex flex-col space-y-6">
                    <div className="flex space-x-6 social-media-links">
                        <a
                            href={ExternalUrls.facebook}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <IconFacebook />
                        </a>
                        <a
                            href={ExternalUrls.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <IconInstagram />
                        </a>
                        <a
                            href={ExternalUrls.twitter}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <IconTwitter />
                        </a>
                    </div>

                    <div className="flex flex-col space-y-6">
                        <div className="flex flex-col items-center md:items-start">
                            <span className="block">
                                Praça Nuno Rodrigues dos Santos 7,
                            </span>
                            <span className="block">
                                1600-171 Lisboa, Portugal
                            </span>
                        </div>
                        <div className="flex flex-col items-center md:items-start">
                            <span className="block">hello@fancollex.com </span>
                            <span className="block">+351 937 354 565</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-center md:justify-between pt-12 text-12">
                <div className="flex space-x-10">
                    <a
                        href={ExternalUrls.termsOfUse}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Terms of Use
                    </a>
                    <a
                        href={ExternalUrls.privacyPolicy}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Privacy Policy
                    </a>
                </div>

                <span className="hidden md:block">
                    Copyright . {getYear()} FanCollex
                </span>
            </div>
        </footer>
    );
}
